import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              大家都在讨论的影视话题
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
            {topics.map((topic) => (
              <a
                key={topic.id}
                href={`#${topic.name}`}
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer no-underline hover:scale-105 ${topic.color}`}
              >
                <span>{topic.name}</span>
                <span className="text-xs opacity-70 whitespace-nowrap">{topic.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}